<section class="container py-5">
  <div class="back-button mb-4">
    <span class="back-icon" (click)="goBack()"><i class="fa-solid fa-arrow-left"></i></span>
    <h4 class="back-button-heading mx-3">My Quotation</h4>
  </div>
  <div class="mat-elevation-z8 table-responsive">
    <table mat-table [dataSource]="dataSource" class="mat-table" matSort>

      <!-- Quotation ID Column -->
      <ng-container matColumnDef="quotation_id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Quotation ID </th>
        <td mat-cell *matCellDef="let element"> <a class="link" (click)="quotationInfo(element.quotation_id)">
            {{element.quotation_id}}</a> </td>
      </ng-container>

      <!-- Expire On Column -->
      <ng-container matColumnDef="expire_on">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Expire On </th>
        <td mat-cell *matCellDef="let element"> {{element.expire_on}} </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
        <td mat-cell *matCellDef="let element"> {{element.status}} </td>
      </ng-container>

      <!-- Travel Dates Column -->
      <ng-container matColumnDef="travel_dates">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Travel Dates </th>
        <td mat-cell *matCellDef="let element"> {{element.travel_dates}} </td>
      </ng-container>

      <!-- Destination Column -->
      <ng-container matColumnDef="destination">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Destination </th>
        <td mat-cell *matCellDef="let element"> {{element.destination}} </td>
      </ng-container>

      <!-- Source Column -->
      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Source </th>
        <td mat-cell *matCellDef="let element"> {{element.source}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

  </div>

</section>